import { render } from "./AiDistillation.vue?vue&type=template&id=31efd0c7&scoped=true"
import script from "./AiDistillation.vue?vue&type=script&lang=js"
export * from "./AiDistillation.vue?vue&type=script&lang=js"

import "./AiDistillation.vue?vue&type=style&index=0&id=31efd0c7&scoped=true&lang=scss"
import "./AiDistillation.vue?vue&type=style&index=1&id=31efd0c7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31efd0c7"]])

export default __exports__